import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList(props = nu) {
  const toast = useToast()

  const refListTable = ref(null)
  const storageProviderFilter = ref('')
  const storageProvider = ref([
    { value: 'local', label: 'Local'},
    { value: 'aws', label: 'AWS'},
    { value: 'huawei', label: 'Huawei'},
    { value: 'azure', label: 'Azure'}
  ]);

  let tableColumns = [

    { label: 'storage_provider.id', key: 'id', sortable: true },
    { label: 'storage_provider.name', key: 'name', sortable: true },
    { label: 'storage_provider.description', key: 'description', sortable: true },
    { label: 'storage_provider.type', key: 'type', sortable: true },
    { label: 'storage_provider.config', key: 'config', sortable: true },
    {
      label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned',
    },
  ]

  if (props.showFilters) {
    tableColumns = [{ label: 'actions.name', key: 'actions' }].concat(tableColumns);
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    let params =  {
      order_by: sortBy.value,
      per_page: perPage.value,
      page: currentPage.value,
      sortDesc: isSortDirDesc.value,
      type: storageProviderFilter.value,
      name: searchQuery.value
    }

    store.dispatch('storage_provider/getAll', params)
      .then(response => {
        callback(response.data)
        totalList.value = response.total
      })
      .catch((e) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage,], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      type: storageProviderFilter.value
    };
    refetchData();
  }

  const clearSearchFilters = () => {
    storageProviderFilter.value = null
    buildFilters();
  }

  return {
    storageProviderFilter,
    storageProvider,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    filtersCount,

    fetchList,
    formatDateAssigned,
    refetchData,
    buildFilters,
    clearSearchFilters,
  }
}
